import { defineComponent, computed } from 'vue';

var script = defineComponent({
    name: 'StatusInfoSubtitle',
    props: {
        darkMode: Boolean,
        subtitle: {
            type: [String, Array],
            default: undefined,
        },
    },
    setup(props) {
        const isArray = (value) => Array.isArray(value);
        const classNames = computed(() => {
            const names = [];
            if (props.darkMode)
                names.push('StatusInfoSubtitle--dark-mode');
            return names;
        });
        return {
            classNames,
            isArray,
        };
    },
});

export { script as default };
